module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"about":"About","terms":"Terms of use","privacy":"Notice of Privacy","contact":"Contact"},"es":{"about":"Acerca de","terms":"Términos de uso","privacy":"Aviso de privacidad","contact":"Contacto"}}')
  delete Component.options._Ctor
}
